// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"8ac26f9a","742":"edb5898e"}[chunkId] + ".chunk.js";
};